import CalendarMonth from '@mui/icons-material/CalendarMonth';
import { FormControl, IconButton, InputAdornment, Stack, TextField } from '@mui/material';
import { DesktopDatePicker, LocalizationProvider, DatePicker as MDatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { format } from 'date-fns';
import React, { useMemo } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import { useTheme } from '@mui/material/styles';
import { toDefaultDateFormat } from 'utils/common';

const formateDate = (date) => {
  return format(new Date(date), 'yyyy/MM/dd');
};

const DatePicker = React.forwardRef(({ onChange, onBlur, id, name, value, className, ...rest }, ref) => {
  const [date, setDate] = React.useState(value);
  const [open, setOpen] = React.useState(false);

  const sanitisedValue = useMemo(() => {
    if (_.isString(date) && date?.includes('/')) {
      return new Date(date);
    }
    return null;
  }, [date]);

  const toggle = () => setOpen(!open);
  const theme = useTheme();
  const OutlinedInputBorderRadius = '12px';

  return (
    <FormControl
      fullWidth
      className={className}
      sx={{
        '.MuiInputBase-root': {
          borderRadius: '12px'
        },
        fieldset: {
          borderRadius: '12px'
        },
        '.MuiFormLabel-root': {
          color: '#446ccc',
          backgroundColor: 'white'
        }
      }}
    >
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <MDatePicker
          inputFormat="yyyy/MM/dd"
          open={open}
          onClose={() => {
            setOpen((v) => !v);
          }}
          onChange={(d) => {
            const fDate = formateDate(d);
            setDate(fDate);
            onChange(fDate);
            // onBlur(d);
          }}
          value={sanitisedValue}
          slots={{
            inputAdornment: (props) => {
              return (
                <InputAdornment position="end" sx={{ ml: 0, mr: '-12px' }}>
                  <Stack direction="row">
                    {!!value && (
                      <IconButton
                        onClick={(e) => {
                          onChange('');
                          setDate('');
                          e.stopPropagation();
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                    )}
                    <IconButton
                      onClick={(e) => {
                        setOpen((v) => !v);
                      }}
                    >
                      <CalendarMonthOutlinedIcon sx={{ color: theme.palette.primary[400] }} />
                    </IconButton>
                  </Stack>
                </InputAdornment>
              );
            }
          }}

          // renderInput={(params) => {
          //   const { inputProps, ...restParams } = params;
          //   return (
          //     <TextField
          //       sx={{
          //         '& .MuiInputBase-input': {
          //           pointerEvents: 'auto'
          //         },
          //         '& .MuiInputBase-root': {
          //           borderRadius: OutlinedInputBorderRadius
          //         }
          //       }}
          //       onClick={toggle}
          //       inputProps={{
          //         disabled: true
          //       }}
          //       fullWidth
          //       {...restParams}
          //       value={sanitisedValue}
          //       name={name}
          //       ref={ref}
          //       InputProps={
          //         rest.disabled
          //           ? {}
          //           : {
          //               endAdornment: (
          //                 <InputAdornment position="end" sx={{ ml: 0 }}>
          //                   <Stack direction="row">
          //                     {/* {!!value && ( */}
          //                     <IconButton
          //                       onClick={(e) => {
          //                         onChange('');
          //                         setDate('');
          //                         e.stopPropagation();
          //                       }}
          //                     >
          //                       <X size={10} />
          //                     </IconButton>
          //                     {/* )} */}
          //                     {/* <IconButton>
          //                       <CalendarMonthOutlinedIcon sx={{ color: theme.palette.primary[400] }} />
          //                     </IconButton> */}
          //                   </Stack>
          //                 </InputAdornment>
          //               )
          //             }
          //       }
          //     />
          //   );
          // }}
        />
      </LocalizationProvider>
    </FormControl>
  );
});

export default DatePicker;
